import { render, staticRenderFns } from "./ed-scan-documents.component.vue?vue&type=template&id=a01e1f42&scoped=true&"
import script from "./ed-scan-documents.component.ts?vue&type=script&lang=ts&"
export * from "./ed-scan-documents.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-scan-documents.component.scss?vue&type=style&index=0&id=a01e1f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01e1f42",
  null
  
)

export default component.exports